import { DISMISS, useNotification } from "collections";
import { DeleteModal, useModalDispatch } from "collections/Modal";
import { useDeleteDeviceGroupsMutation } from "generated/graphql";
import React from "react";
import { protect } from "TsRoleGuards";
import { useTranslation } from "utilities/i18n";

const DeleteDeviceGroupsModal: React.FC<{
  groups: Array<string>;
  onSuccess: () => void;
}> = ({ groups, onSuccess }) => {
  const { t } = useTranslation();
  const [addNotification] = useNotification();
  const dismissModal = useModalDispatch();
  const [, deleteGroups] = useDeleteDeviceGroupsMutation();

  const deleteDeviceGroups = async () => {
    const { data, error } = await deleteGroups({
      groups: { gIds: groups }
    });
    const response = data?.deleteGroups;
    if (response?.success) {
      addNotification({
        type: "success",
        dismiss: DISMISS.DEFAULT,
        message: t("SUCCESSFULLY_DELETED", {
          entity: t("DEVICE_GROUP", { count: groups.length })
        }),
        persistThroughNav: true
      });

      onSuccess();
    } else if (response?.error || error) {
      addNotification({
        type: "error",
        dismiss: DISMISS.DEFAULT,
        message: (response?.error || error?.message) ?? "err"
      });
    }
    dismissModal();
  };

  return (
    <DeleteModal
      entity={t("DEVICE_GROUP", { count: groups.length })}
      confirmationString={t("CONFIRM_DELETE_DEVICE_GROUPS", {
        count: groups.length
      })}
      onDelete={deleteDeviceGroups}
      name="DeleteDeviceGroup"
    />
  );
};

export default protect("UPDATE_SITES")(DeleteDeviceGroupsModal);
